import React from 'react';
/**
 * ScrollLock
 * Locks the scroll of the body while rendered
 */
const ScrollLock: React.FCWithChildren = () => <style>{`body {overflow: hidden;}`}</style>;

export default ScrollLock;
